import React from 'react';
import '../../css/app/recorder.css';

const Modal = ({ children, onClose, modaltxt, closeButtonDisabled, btnnone }) => {
    return (
        <div className="modal d-block vr-mmodal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered vr-mmodal-dialog" role="document">
                <div className="modal-content vr-mmodal-content">
                    <div className="modal-header border-0 d-flex align-items-center justify-content-between vr-mmodal-header" >
                        <div>
                            <h5 className="modal-title mb-0 vr-mmodal-title">{modaltxt}</h5>
                        </div>
                        <div>
                            <button type="button" className={`close vr-mmodal-close${closeButtonDisabled ? " is-disabled" : ""}`}
                                aria-label="Close"
                                disabled={closeButtonDisabled}
                                style={{
                                    display:btnnone?"none":'',
                                }}
                                onClick={() => {
                                    if (!closeButtonDisabled) {
                                        onClose();
                                    }
                                }}
                                // onClick={onClose}
                                
                                >
                                <span aria-hidden="true" className="vr-mmodal-x">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div className="modal-body vr-mmodal-body">
                        {children}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Modal;
